import React from 'react';
import PropTypes from 'prop-types';
import BetSlipInput from 'Components/BetSlip/Input';
import { classnames } from 'Utils/classnames';
import Icon from 'Components/Icon';
import EnvironmentManager from '../../../../../utils/environmentManager';
import { useSelector } from 'react-redux';

const BetSlipInfoItem = ({
  id,
  label,
  value,
  type,
  inputMaxLength,
  onChange,
  onBlur,
  className,
  onFocus,
  onClick,
  disabled,
  labelIcon,
  onLabelClick,
  isHtw,
  htwValue,
  isMaxWin
}, ref) => {

  const renderValue = () => {
    if (type === 'input') {
      return <BetSlipInput
        id={ id }
        maxLength={ inputMaxLength }
        value={ value }
        onFocus={ onFocus }
        onClick={ onClick }
        onChange={ onChange }
        onBlur={ onBlur }
        ref={ ref }
        disabled={ disabled }
      />;
    }
    const zirveOranSwitch = EnvironmentManager.getMessageText({ key: 'zirveoran_switch' }) == 'true';
    const { topWinEnabled } = useSelector(state => state?.auth?.data);
    const showHtw = zirveOranSwitch && topWinEnabled && htwValue;
    if (type === 'clickable') {
      return <a className={ `${ disabled ? 'betslip__input__disabled' : ''  } betslip__input` } title={ value } href="#" onClick={ onClick } id={ id }>
        <div className="betslip__input__value">{ value }</div>

        <Icon className="betslip__input__icon" iconName="svgArrowRight" />
      </a>;
    }

    return <span ref={ ref }>
      { showHtw ? (
        <div className="betslip__input__wrapper">
          <span className="betslip__input__oldValue">{ value }</span>
          <span className="betslip__input__htwValue">{ htwValue }</span>
        </div>
      ) : (
        value
      ) }
    </span>;
  };

  return (
    <div className={ classnames({
      'betslip__footer__selections__info-item': true,
      [className]: className
    }) } >
      <div className="betslip__footer__selections__info-item__label" onClick={ onLabelClick }>
        <span>
          { label }
        </span>
        { labelIcon }
      </div>

      <div className={ classnames({
        'betslip__footer__selections__info-item__value': true,
        'betslip__footer__selections__info-item__value--max-profit': isMaxWin
      }) }>
        { renderValue() }
      </div>
    </div>
  );
};

BetSlipInfoItem.propTypes = {
  id: PropTypes.string,
  label: PropTypes.string,
  isHtw: PropTypes.bool,
  htwValue: PropTypes.string,
  value: PropTypes.any,
  type: PropTypes.string,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  onFocus: PropTypes.func,
  onClick: PropTypes.func,
  onValueClick: PropTypes.func,
  inputMaxLength: PropTypes.number,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  labelIcon: PropTypes.object,
  onLabelClick: PropTypes.func,
  isMaxWin: PropTypes.bool
};

export default React.forwardRef(BetSlipInfoItem);
